import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import DialogContentText from "@material-ui/core/DialogContentText";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Check";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

// styles
import styles from "./styles";

class FormInstrument extends Component {
  static propTypes = {
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    instrument: PropTypes.object,

    createInstrument: PropTypes.func,
    updateInstrument: PropTypes.func,
    deleteInstrument: PropTypes.func,

    musicalFamilies: PropTypes.array,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      name: "",
      musicalFamilyID: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.instrument);
    }
  }

  handleChange = (v) => (event) => {
    const { target } = event;
    const { value } = target;

    this.setState({
      [v]: value,
    });
  };

  init(instrument) {
    this.setState({
      loading: false,
      name: instrument ? instrument.name : "",
      musicalFamilyID: instrument ? instrument.musicalFamilyID : "",
    });
  }

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: "Are you sure ?",
        subtitle:
          "If you delete this instrument, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          instrument: "default",
        },
        confirm: {
          label: "I am sure",
          instrument: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const { deleteInstrument, instrument, close, refresh } = this.props;

    const { NotificationCenter } = this.context;

    const resp = await deleteInstrument(instrument.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "Instrument has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const {
      updateInstrument,
      createInstrument,
      close,
      instrument,
      refresh,
    } = this.props;

    const { name, musicalFamilyID } = this.state;

    const { NotificationCenter } = this.context;

    let resp;
    this.setState({ loading: true });
    if (instrument) {
      resp = await updateInstrument(instrument.id, {
        name,
        musicalFamilyID,
      });
    } else {
      resp = await createInstrument({
        name,
        musicalFamilyID,
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      refresh();
      close();
      NotificationCenter.sweetAlert({
        title: instrument
          ? "Instrument has been updated."
          : "Instrument has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      setTimeout(NotificationCenter.hide, 2000);
    }
  }

  render() {
    const {
      classes,
      fullScreen,
      open,
      instrument,
      close,
      musicalFamilies,
    } = this.props;

    const { name, musicalFamilyID, loading } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        onClose={close}
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {instrument
                ? `${instrument.name}`
                : "Let's Create a New Instrument"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {instrument
                  ? "To update the instrument, fill the form below :"
                  : "To create a new instrument, fill the form below :"}
              </DialogContentText>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    label="Name"
                    className={classes.textField}
                    value={name}
                    onChange={this.handleChange("name")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl className={classes.formControl} fullWidth>
                    <InputLabel htmlFor="group-simple">
                      Musical Family
                    </InputLabel>
                    <Select
                      value={musicalFamilyID}
                      onChange={this.handleChange("musicalFamilyID")}
                    >
                      {musicalFamilies.map((mf) => (
                        <MenuItem key={`mf_${mf.id}`} value={mf.id}>
                          {mf.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {instrument && (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} />
                  &nbsp;Delete
                </Button>
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} />
                &nbsp;Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />
                {instrument ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormInstrument));
